import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { ICodeSchemaPartial } from '../../type/code';
import { ITranslationSubTypeInput } from '../../type/_inputTypes/translation';

export interface ICreateCodeMutationFields {
  label: ITranslationSubTypeInput[];
  description: ITranslationSubTypeInput[];
  status: boolean;
  company?: string;

  codeType: string;
  code: string;
  codeDomainName: string;
  codeDestinationType: string;
  codeDestinationUrl?: string;
  codeDestinationUser?: string;
  codeDestinationCompanyAddress?: string;
  codeDestinationPhones?: string[];
  codeDestinationEmails?: string[];
  codeDestinationIncludeProfileLink?: boolean;
  codeDestinationCompanyWebsite?: string;
}


export interface ICreateCodeMutationResponseFields {
  createdCode: ICodeSchemaPartial;
}


export function createCodeMutation(fragment: string): DocumentNode {
  return gql`
        mutation createCode (
        $label: [TranslationSubTypeInput]!,
$description: [TranslationSubTypeInput]!,
$status: Boolean!,
$company: String,
$codeType: String!,
$code: String!,
$codeDomainName: String!,
$codeDestinationType: String!,
$codeDestinationUrl: String,
$codeDestinationUser: String,
$codeDestinationCompanyAddress: String,
$codeDestinationPhones: [String],
$codeDestinationEmails: [String],
$codeDestinationIncludeProfileLink: Boolean,
$codeDestinationCompanyWebsite: String
        ) {
        createCode (
        label: $label,
description: $description,
status: $status,
company: $company,
codeType: $codeType,
code: $code,
codeDomainName: $codeDomainName,
codeDestinationType: $codeDestinationType,
codeDestinationUrl: $codeDestinationUrl,
codeDestinationUser: $codeDestinationUser,
codeDestinationCompanyAddress: $codeDestinationCompanyAddress,
codeDestinationPhones: $codeDestinationPhones,
codeDestinationEmails: $codeDestinationEmails,
codeDestinationIncludeProfileLink: $codeDestinationIncludeProfileLink,
codeDestinationCompanyWebsite: $codeDestinationCompanyWebsite
        ) {
        ...fragment
        }
        }
        fragment fragment on CreateCodeMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useCreateCodeMutation<TData extends Partial<ICreateCodeMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ createCode: TData },
        ICreateCodeMutationFields>,
) {
  return useMutation<{ createCode: TData },
      ICreateCodeMutationFields>(
        createCodeMutation(fragment), options,
      );
}
